import { PureComponent } from "react";
import { componentStyles } from "./all-rights-reserved-component.scss.js";
import MONDAY_LOGO from "/static/svg/monday-logos/monday-logo.svg";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withRouter } from "next/router";
import GooglePlayBig from "static/svg/social/google_play_big.svg";
import AppStoreBig from "static/svg/social/app_store_big.svg";
import { IOS_APP_DOWNLOAD_LINK, ANDROID_APP_DOWNLOAD_LINK } from "constants/links";

class AllRightsReservedComponent extends PureComponent {
  getText() {
    const { translate } = this.props;
    return translate("allRightsReserved");
  }

  render() {
    const { Phone, translate } = this.props;

    return (
      <div className="all-rights-reserved-component">
        <div>
          <div className="monday-logo-wrapper">
            <a href="/">
              <MONDAY_LOGO />
            </a>
          </div>
          <p className="details">{this.getText()} © monday.com</p>
        </div>

        <div className="app-store-icons">
          <a
            target="_blank"
            className="app-icon"
            href={ANDROID_APP_DOWNLOAD_LINK}
            title="Download the monday android App from Google Play"
          >
            <GooglePlayBig />
          </a>
          <a
            target="_blank"
            className="app-icon"
            href={IOS_APP_DOWNLOAD_LINK}
            title="Download the monday iOS App from the App Store"
          >
            <AppStoreBig />
          </a>
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

export default withGenericConfig(withRouter(AllRightsReservedComponent));
